__webpack_require__.p = "/apps/bbb/js/";